// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Selectors
import { selectIsDesktopAppMode } from '../../../../platform/platformSelector';

// Actions
import { closePopup } from '../../../../components/popupPanel/popupActions';
import { switchToDesktopMode, switchToMobileMode } from '../../../../utils/grid/gridActions';

// Components
import LinkButton from '../../../../components/buttons/LinkButton';
import PopupPanelAsideSection from '../../../../components/popupPanel/types/asideSection/PopupPanelAsideSection';

const MobileSwitchCanvasView = () => {
    const isDesktopAppMode = useSelector(selectIsDesktopAppMode);

    const dispatch = useDispatch();

    const dispatchSwitchToDesktopMode = () => {
        dispatch(closePopup());
        dispatch(switchToDesktopMode());
    };

    const dispatchSwitchToMobileMode = () => {
        dispatch(closePopup());
        dispatch(switchToMobileMode());
    };

    return (
        <PopupPanelAsideSection className="MobileSwitchCanvasView">
            {isDesktopAppMode ? (
                <LinkButton onClick={dispatchSwitchToMobileMode}>Switch to mobile view</LinkButton>
            ) : (
                <LinkButton onClick={dispatchSwitchToDesktopMode}>Switch to desktop view</LinkButton>
            )}
        </PopupPanelAsideSection>
    );
};

export default MobileSwitchCanvasView;
